export const API_ERRORED = "API_ERRORED";
export const DATA_REQUESTED_LIKE = "DATA_REQUESTED_LIKE";
export const DATA_LOADED_LIKE = "DATA_LOADED_LIKE";
export const DATA_POST_LIKE = "DATA_POST_LIKE";
export const DATA_GET_LIKE = "DATA_GET_LIKE";
